import { findRoomReportDetail, findRoomUsedTimes } from '../services/report';
import { routerRedux } from 'dva/router';
import { PATH_HOME } from '../utils/constants';

const pageData = (page, pageSize, data) => {
  let p = Number(page);
  let size = Number(pageSize);
  let newarr = Object.keys(data);
  let start = (p - 1) * size;
  let end = p * size;
  let a = newarr.slice(start, end);
  let m = {};
  a.forEach(item => {
    m[item] = data[item];
  });
  return m;
};

export default {
  namespace: 'roomReportDetails',
  state: {
    meetingName: '',
    roomId: '',
    startTime: '',
    endTime: '',
    details: {},
    useTimes: {},
    pageSize: 30,
    pageNo: 1,
    // 底部热力图的state
    userTimesLen: 0,
    userTimesPageNo: 1,
    userTiemsPageSize: 10,
    userTimesData: []
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *clickRoomDetail(
      { roomId, startTime, endTime, meetingName },
      { call, select, put }
    ) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      let pageNo = yield select(state => state.roomReportDetails.pageNo);
      let pageSize = yield select(state => state.roomReportDetails.pageSize);
      yield put({
        type: 'setState',
        payload: {
          roomId: roomId,
          startTime: startTime,
          endTime: endTime,
          meetingName: meetingName
        }
      });
      let data = yield call(findRoomReportDetail, {
        token: token,
        roomId,
        startDate: startTime,
        endDate: endTime,
        lang: locale,
        pageNo,
        pageSize
      });
      yield put({ type: 'setState', payload: { details: data } });
      let res = yield call(findRoomUsedTimes, {
        token: token,
        roomId,
        startDate: startTime,
        endDate: endTime,
        lang: locale,
        pageNo,
        pageSize
      });
      if (res.data) {
        // yield put({type:'setState', payload: {useTimes: res}})
        // 这里前端处理分页，单独写一个方法
        let userTimesData =
          res.data && res.data.data && pageData(1, 10, res.data.data);
        let total = res.data.data && Object.keys(res.data.data).length;
        yield put({
          type: 'setState',
          payload: { useTimes: res, userTimesData, userTimesLen: total }
        });
      }
      yield put(
        routerRedux.push({
          pathname: `${PATH_HOME}roomReportDetails`,
          query: { detail: true }
        })
      );
    },
    *changePage({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.roomReportDetails.startTime);
      let endTime = yield select(state => state.roomReportDetails.endTime);
      let pageNo = yield select(state => state.roomReportDetails.pageNo);
      let pageSize = yield select(state => state.roomReportDetails.pageSize);
      let roomId = yield select(state => state.roomReportDetails.roomId);
      const { locale } = yield select(state => state.i18n);
      let data = yield call(findRoomReportDetail, {
        token: token,
        roomId,
        startDate: startTime,
        endDate: endTime,
        lang: locale,
        pageNo,
        pageSize
      });
      yield put({ type: 'setState', payload: { details: data } });
      let res = yield call(findRoomUsedTimes, {
        token: token,
        roomId,
        startDate: startTime,
        endDate: endTime,
        lang: locale,
        pageNo,
        pageSize
      });
      yield put({ type: 'setState', payload: { useTimes: res } });
    },
    *changeUserTimesPage({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      let pageNo = yield select(
        state => state.roomReportDetails.userTimesPageNo
      );
      let pageSize = yield select(
        state => state.roomReportDetails.userTiemsPageSize
      );
      let res = yield select(state => state.roomReportDetails.useTimes);
      let userTimesData =
        res.data && res.data.data && pageData(pageNo, pageSize, res.data.data);
      let total = res.data.data && Object.keys(res.data.data).length;
      yield put({
        type: 'setState',
        payload: { userTimesData, userTimesLen: total }
      });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {});
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/roomReportDetails.js